import { Directive, ElementRef, HostListener, input, inject } from '@angular/core';

import { ApInputConstraintService } from './input-constraint.service';

@Directive({
    selector: '[apInputConstraint]',
    providers: [ApInputConstraintService]
})
export class ApInputConstraintDirective {
    elementRef = inject(ElementRef);
    private readonly inputConstraintService = inject(ApInputConstraintService);

    /**
     * Pattern that strips input value from disallowed characters
     */
    public readonly stripPattern = input<RegExp>(undefined);

    /**
     * Capture input event. On input strip value from disallowed characters
     * @ignore
     */
    @HostListener('input')
    public onInput(): void {
        const nativeElement = this.elementRef.nativeElement;
        const value = this.inputConstraintService.strip(nativeElement.value, this.stripPattern());
        if (value !== nativeElement.value) {
            const caret = nativeElement.selectionStart - 1;
            nativeElement.value = value;
            // prevent caret from jumping to end when infixing
            nativeElement.setSelectionRange(caret, caret);
        }
    }
}
